import ExcelJS from 'exceljs';

interface ErrorEntry {
  index: number;
  values: string;
  errorCode: {
    name: string;
    message: string;
  };
  detailMessage?: string;
}

/**
 * 将导入失败的用户信息生成 Excel 文件并触发下载
 * 遵循导入模板格式规范，确保用户修正后可直接导入
 * @param errorEntries - 失败的用户条目数组
 * @param t - i18n 翻译函数
 */
export const downloadFailedImportUsers = async (errorEntries: ErrorEntry[], t: (key: string) => string) => {
  const workbook = new ExcelJS.Workbook();
  const worksheet = workbook.addWorksheet(t('adminConsole.newConsole.import.importFailed'));

  // 设置列宽（前6列与模板保持一致 + 错误信息列）
  worksheet.columns = [
    { width: 5 }, // 序号列
    { width: 8 }, // 标记列
    { width: 20 }, // 姓名列
    { width: 35 }, // 邮箱列
    { width: 25 }, // 部门列
    { width: 40 }, // 角色列
    { width: 35 }, // 错误信息列
  ];

  // 第1行：空行（5个空列）- 接口要求的格式
  const row1 = worksheet.addRow(['', '', '', '', '', '', '']);
  row1.height = 20;

  // 第2行：模板头部 + 错误信息列
  const headerRow = worksheet.addRow([
    ...t('adminConsole.newConsole.import.templateHeader').split(','),
    t('adminConsole.newConsole.import.import_table_error'),
  ]);
  headerRow.height = 100;
  headerRow.eachCell((cell) => {
    cell.alignment = { vertical: 'middle', wrapText: true };
    cell.font = { bold: true };
  });

  // 第3行开始：失败数据行（最后一列为错误信息）
  errorEntries.forEach((entry) => {
    const values = entry.values.split(',');
    const errorMessage = t(`adminConsole.tip.${entry.errorCode.name}`);
    const row = worksheet.addRow([...values, errorMessage]);
    row.height = 25;
    row.eachCell((cell, colNumber) => {
      cell.alignment = { vertical: 'middle', wrapText: true };
      // 第6列是角色/权限等级列，设置为文本格式防止转换为浮点数
      if (colNumber === 6) {
        cell.numFmt = '@';
      }
    });
  });

  // 生成 Excel 文件并下载
  const buffer = await workbook.xlsx.writeBuffer();
  const blob = new Blob([buffer], {
    type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
  });
  const link = document.createElement('a');
  const url = URL.createObjectURL(blob);
  link.setAttribute('href', url);
  link.setAttribute('download', `${t('adminConsole.newConsole.import.importFailedUsers')}.xlsx`);
  link.style.visibility = 'hidden';
  document.body.appendChild(link);
  link.click();
  document.body.removeChild(link);
  URL.revokeObjectURL(url);
};
